import {Progress} from "antd";
import {eliga_AF9} from "@/theme/palette";
import SpaceViewModel from "@contents/viewModels/spaceViewModel";
import {useEffect, useRef, useState} from "react";
import CONSTANTS from "@utils/constants";
import {KEYS} from "@app/constants/keys";
import {useRecoilState, useResetRecoilState} from "recoil";
import {isShopCopyState} from "@services/stores/storeState";
import {ShopCopySaveModel} from "@contents/models/commonModel";
import {isEmptyObject, isEmptyString} from "@utils/commonUtils";
import {eAlert} from "@app/events";
import {Strings} from "@app/constants/strings";

const ShopCopyProgressBar = () => {
    const spaceView = SpaceViewModel();

    const intervalRef = useRef<any>(null);
    const [trigger, setTrigger] = useState<number>(0);
    const [progressPercent, setProgressPercent] = useState<number>(0);
    const [hasData, setHasData] = useState<boolean>(true);

    const {getShopCopyProgress, shopProgressData, shopCopyProgressResult} = spaceView;
    const [isShopCopied, setIsShopCopied] = useRecoilState(isShopCopyState);
    const resetIsShopCopy = useResetRecoilState(isShopCopyState);
    const [shopCopySavedInfo, setShopSavedInfo] = useState<ShopCopySaveModel | undefined>(undefined);

    useEffect(() => {
        //progress 가져온다.
        const shopCopySavedData = localStorage.getItem(KEYS.SHOP_COPY) || '';
        if (isEmptyString(shopCopySavedData)) {
            _finInterval();
            return;
        }
        const shopCopySaved = (JSON.parse(shopCopySavedData) as ShopCopySaveModel);

        if (isShopCopied) {
            //버튼에 의해서 shop복사 진행했을 때
            setShopSavedInfo(shopCopySaved);
            //진행률을 부른다.
            getShopCopyProgress();
        } else {
            //브라우저 다시 켰을 때
            setIsShopCopied(true);
        }
    }, [isShopCopied]);

    useEffect(() => {
        console.log('ShopCopyProgressBar', shopCopyProgressResult?.dataUpdatedAt);
        console.log('ShopCopyProgressBar', shopProgressData);
        if (shopProgressData?.progress === 0 && shopProgressData?.total === 0) {
            //진행률이 progress: 0, total: 0인 경우
            console.log('ShopCopyProgressBar: 0');
            if (hasData) {
                setHasData(false);
                setTrigger((prev) => prev + 1);
            } else {
                //한번 시도 후 서버에서 받은 데이터가 없기에 바로 종료
                console.log('ShopCopyProgressBar: hasData');
                _finInterval();
            }
            return;
        }

        if (shopProgressData?.progress && shopProgressData?.total && shopProgressData?.progress >= shopProgressData?.total) {
            console.log('ShopCopyProgressBar: fin');
            //프로세스가 완전히 종료된 경우: FIN
            eAlert(Strings.alert.shopCopyFin);
            _finInterval();
            return;
        }

        if (shopProgressData && !isEmptyObject(shopProgressData)) {
            setProgressPercent((prev) => {
                return (shopProgressData?.progress !== undefined ? shopProgressData.progress : prev);
            });
            setTrigger((prev) => prev + 1);
        }
    }, [shopProgressData?.progress, shopProgressData?.total, shopCopyProgressResult.dataUpdatedAt]);

    useEffect(() => {
        if (shopCopyProgressResult.isError) {
            console.log('shopCopyProgressResult: error');
            _finInterval();
        }
    }, [shopCopyProgressResult.isError]);

    useEffect(() => {
        if (intervalRef.current) return;

        if (trigger <= 0) return;

        let count = 0;
        intervalRef.current = window.setInterval(() => {
            setProgressPercent((prev) => {
                console.log('ShopCopyProgressBar: countTimer', progressPercent + ' ' + count);
                return prev + CONSTANTS.SHOP_COPY_POLLING
            });
            count += 1;

            if (count >= CONSTANTS.SHOP_COPY_POLLING) {
                getShopCopyProgress();
                _initializeInterval();
            }
        }, 1000);

        return () => _initializeInterval();
    }, [trigger]);

    const _initializeInterval = () => {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
    }

    const _finInterval = () => {
        _initializeInterval();
        localStorage.removeItem(KEYS.SHOP_COPY);
        resetIsShopCopy();
        setShopSavedInfo(undefined);
        setProgressPercent(0);
        setTrigger(0);
    }

    return (
        <>
            {
                (!isEmptyString(shopCopySavedInfo?.uuid || '') && (shopProgressData?.progress !== undefined && shopProgressData?.total !== undefined && shopProgressData?.progress <= shopProgressData?.total)) ?
                    <Progress
                        type={'line'}
                        strokeColor={eliga_AF9.main}
                        showInfo={false}
                        strokeLinecap={'square'}
                        percent={((progressPercent / (shopProgressData ? (shopProgressData?.total || 500) : 100)) * 100)}
                        style={{
                            width: '100%',
                            margin: 0,
                            padding: 0,
                            lineHeight: 0,
                            display: 'block',
                            position: 'sticky',
                            zIndex: 9999,
                            top: 0
                        }}
                    />
                    :
                    <></>
            }
        </>
    )
}
export default ShopCopyProgressBar;